module.exports = __webpack_public_path__ + "static/media/tempThreshold.bbe46742.xls";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/excelTeml/tempThreshold.xls
// module id = 5156
// module chunks = 0